<igx-grid [batchEditing]="true" #gridProfileParkers [data]="this.parkerStateService.filteredParkers" [width]="'99%'" [height]="'2000px;'" [autoGenerate]="false" style=margin-left:10px;margin-top:10px;
paste-handler  [primaryKey]="'parkerId'" [rowEditable]="false" [allowFiltering]="true"  filterMode="excelStyleFilter" displayDensity="compact" 
[emptyGridMessage]="'Parker Profile List Empty'"   >

<igx-column field="view" header=" " width="50px" required ></igx-column>

<igx-column field="active" header="Active*" [sortable]="true" width="90px" required ></igx-column>
<igx-column field="cardNumber" header="Card No." width="90px" required ></igx-column>
<igx-column field="stallType" header="Stall Type" width="125px" required ></igx-column>
<igx-column field="stallNumber" header="Stall #" width="90px" required ></igx-column>
<igx-column field="companyName" header="Company" width="150px" required ></igx-column>

</igx-grid>
